import React from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
  Divider,
} from "@mui/material";
import noTableData from "../../assets/images/noTableData.svg";

const STATUS_STYLE = {
  Excellent:          { bgcolor: "#DCFCE7", color: "#16A34A" },
  Good:               { bgcolor: "#EEF2FF", color: "#4F46E5" },
  "Needs Improvement":{ bgcolor: "#FEF3C7", color: "#D97706" },
};

const COLS = ["SUPPLIER", "SUBMITS", "INTV RATIO", "HIRES", "STATUS"];

const SupplierScorecards = ({ data, loading }) => {
  return (
    <Paper elevation={0} sx={{ border: "1px solid #E2E8F0", borderRadius: 2, p: 2.5, height: 420, display: "flex", flexDirection: "column" }}>

      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6" fontWeight={700} color="text.primary">
          Supplier Scorecards
        </Typography>
      </Box>

      <Divider sx={{ mb: 0 }} />

      {loading ? (
        <Box sx={{ display: "flex", height: 220, justifyContent: "center", alignItems: "center" }}>
          <CircularProgress sx={{ color: "#6366F1" }} />
        </Box>
      ) : !data || data.length === 0 ? (
        <Box sx={{ height: 220, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
          <img src={noTableData} width={60} alt="No Data" />
          <Typography mt={0.75} fontWeight={500} fontSize={18} fontFamily="'Noto Sans', sans-serif">
            No supplier data to show.
          </Typography>
        </Box>
      ) : (
        <TableContainer sx={{ maxHeight: 275, overflowY: "auto" }}>
          <Table size="small" stickyHeader aria-label="supplier scorecards">
            <TableHead>
              <TableRow>
                {COLS.map((col) => (
                  <TableCell
                    key={col}
                    sx={{
                      backgroundColor: "#fff",
                      fontWeight: 700,
                      fontSize: "11px",
                      textTransform: "uppercase",
                      letterSpacing: "0.07em",
                      color: "#94A3B8",
                      borderBottom: "1px solid #E2E8F0",
                      py: 1.5,
                    }}
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => {
                const style = STATUS_STYLE[row.status] || { bgcolor: "#F1F5F9", color: "#64748B" };
                return (
                  <TableRow key={row.supplierId} sx={{ "&:last-child td": { border: 0 } }}>
                    <TableCell sx={{ fontWeight: 700, fontSize: 14, color: "#111827", py: 1.75 }}>
                      {row.supplierName}
                    </TableCell>
                    <TableCell sx={{ fontSize: 14, color: "#6B7280" }}>{row.submits}</TableCell>
                    <TableCell sx={{ fontSize: 14, color: "#6B7280" }}>{row.intvRatio}%</TableCell>
                    <TableCell sx={{ fontSize: 14, color: "#6B7280" }}>{row.hires}</TableCell>
                    <TableCell>
                      <Chip
                        label={row.status.toUpperCase()}
                        size="small"
                        sx={{
                          bgcolor: style.bgcolor,
                          color: style.color,
                          fontWeight: 700,
                          fontSize: "11px",
                          borderRadius: "6px",
                          height: 24,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default SupplierScorecards;
